import OpponentsList from "@/page-components/matches/opponents/list";
import { PageHeader, PageTitle } from "@/util-components/page-layout";
import { Flag } from "lucide-react";

const OpponentsPage = () => {
  return (
    <div className="h-full w-full flex flex-col bg-gray-50">
      <PageHeader>
        <PageTitle
          title="Gegner"
          icon={Flag}
          iconColor="text-blue-600"
          iconBg="bg-blue-50"
        />
      </PageHeader>

      <main className="flex-1 overflow-y-auto">
        <div className="min-h-full">
          <OpponentsList />
        </div>
      </main>
    </div>
  );
};

export default OpponentsPage;
